import type { WeakValidationMap } from 'react';
import type React from 'react';
import { useCallback } from 'react';
import { describe, PropTypes } from '../props-helpers/index.js';

const propTypes = {
  onBlur: PropTypes.func
    .description('The function to be invoked when focus exits the wrapping container')
    .signature('((e: React.FocusEvent, ...args: unknown[]) => void)').isRequired,
} as WeakValidationMap<unknown>;

type OnBlurCb = (e: React.FocusEvent, ...args: unknown[]) => void;
type UseOnBlurOut = ({ onBlur }: { onBlur: OnBlurCb }) => OnBlurCb;
const useOnBlurOut: UseOnBlurOut = ({ onBlur }) =>
  useCallback<OnBlurCb>(
    (e, ...args) => {
      const { currentTarget } = e;
      // Give browser time to focus the next element
      requestAnimationFrame(() => {
        // Check if the new focused element is a child of the original container
        if (!currentTarget.contains(document.activeElement)) {
          onBlur(e, ...args);
        }
      });
    },
    [onBlur],
  );

const UseOnBlurOutWithSchema = describe(useOnBlurOut);
UseOnBlurOutWithSchema.propTypes = propTypes;

export { useOnBlurOut, UseOnBlurOutWithSchema };
